import {AfterViewInit, Component, Input, OnInit, Type} from '@angular/core';
import {DatepickerDialogComponent} from './datepicker-dialog/datepicker-dialog.component';
import {FormItemBaseComponent} from '../../bases/form-item-base-component';
import {MatFormFieldAppearance} from '@angular/material/form-field';
import {PeriodsService} from '../../services/periods.service';
import * as lodash from "lodash";
import {AdRPeriod, AdRPeriodType} from '../../interfaces/ad-reports';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss']
})
export class DatepickerComponent extends FormItemBaseComponent implements OnInit, AfterViewInit {
  @Input('control') public control: FormControl;
  @Input('options') public options: Array<AdRPeriod> = this._periodsS.getPeriods();
  @Input('centerPosition') public centerPosition: boolean;
  @Input('appearance') public appearance: MatFormFieldAppearance;
  @Input('labelAnimation') public labelAnimation: boolean = true;
  @Input('label') public label: string = 'select.period';
  @Input('disableComparison') public disableComparison: boolean;
  @Input('onlyCustomComparison') public onlyCustomComparison: boolean = false;

  @Input('defaultPeriod') private set _setDefaultPeriod(type: AdRPeriodType) {
    if (type && this.control && !this.control.value) {
      this.initValue(type);
      this.defaultPeriod = type;
    }
  }

  @Input('value') private set _setValue(value: AdRPeriod) {
    if (value && this.control) {
      this.initValue(value?.type, value);
    }

    this.value = value;
  }

  public panelComponent: Type<DatepickerDialogComponent> = DatepickerDialogComponent;
  public defaultPeriod: AdRPeriodType = 'last_30_days';

  public openDialogConfigGetter: Function = () => {
    this.value = this.control.value;

    return {
      inputData: {
        defaultValue:       this.value,
        comparisonValue:    this.form.get('compare')?.value?.value,
        options:            this.options,
        disableComparison:  this.disableComparison,
        onlyCustomComparison: this.onlyCustomComparison
      }
    };
  }

  constructor(
    private readonly _periodsS: PeriodsService
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngAfterViewInit(): void {}

  public initValue(type: AdRPeriodType, option: any = {}): void {
    let value: AdRPeriod = this.options.find((opt: AdRPeriod): boolean => opt.type === type);

    if (value) {
      value = Object.assign(value, option);

      this.control.setValue(value);
    }
  }

  public selectTextGetter(period: AdRPeriod): string {
    return period.name;
  }

  public selectValueGetter(period: AdRPeriod): AdRPeriod {
    return period;
  }

  public onClose(data: any): void {
    if (data) {
      const option: AdRPeriod = this.options.find((opt: AdRPeriod): boolean => opt.type === data.period.type);

      const newOption: AdRPeriod = lodash.clone(option);
      const optionK: number = this.options.indexOf(option);

      for (const key in data.period) {
        newOption[key] = data.period[key];
      }

      this.options.splice(optionK, 1, newOption);
      this.control.setValue(newOption);

      if (this.form.contains('compare')) {
        this.form.get('compare').setValue(data.comparison && { on: 'period', value: data.comparison } || { on: false, value: null });
      }
    }
  }

}
